module.exports = __webpack_public_path__ + "static/media/A+.a6e45945.svg";